import dayjs, { Dayjs } from 'dayjs'

const MIN_DATE_ERROR_AFTER_EFFECTIVE = 'Expiration date must be after effective date'
const MIN_DATE_ERROR_FUTURE = 'Expiration date should be at least 1 day in the future'
const MAX_EXPIRATION_MONTHS = 12

export const MAX_EXPIRATION_DATE_HINT = `Set an expiration date up to ${MAX_EXPIRATION_MONTHS} months from today.`

export const MAX_DATE_ERROR = `Expiration date can't be more than ${MAX_EXPIRATION_MONTHS} months from today`

export function getExpirationMaxDate(): Dayjs {
  return dayjs().add(MAX_EXPIRATION_MONTHS, 'month')
}

export function getExpirationMinDate(effectiveAt: string | null | undefined): {
  minDate: Dayjs
  minDateError: string
} {
  const tomorrow = dayjs().add(1, 'day')
  const effectivePlusOne = effectiveAt ? dayjs(effectiveAt).add(1, 'day') : null

  if (effectivePlusOne?.isAfter(tomorrow)) {
    return {
      minDate: effectivePlusOne,
      minDateError: MIN_DATE_ERROR_AFTER_EFFECTIVE,
    }
  }

  return {
    minDate: tomorrow,
    minDateError: MIN_DATE_ERROR_FUTURE,
  }
}
